import type { JSX } from 'react';
import { IconBellNotification, Pastille, cn, useNotificationsPort } from '@taki/ui';

import { ouvrirCentre } from '../centre/ouvrirCentre.js';
import { texteDuBadge } from './source.js';

/**
 * LA CLOCHE DU DOCK : le total des non lus de la boite interne (le meme que le
 * centre de communication lit), et un clic qui ouvre la FENETRE DE
 * COMMUNICATION sur sa rubrique Notifications (R7 du soir du 05/10/2026 : plus
 * de boite a part collee au dock). Fenetre ouverte ailleurs : elle passe sur
 * Notifications ; deja sur Notifications : elle se ferme (`gesteDuLanceur`).
 * Le dock la rend a sa place (avant Reglages) par `renderCloche`, avec sa
 * propre classe de ligne : la cloche a la meme silhouette que ses voisines.
 */
export interface ClocheNotificationsProps {
  /** Le dock deplie : le libelle s'affiche a cote de l'icone. */
  expanded: boolean;
  /** La classe d'une ligne du dock (`cnDock`). */
  className: string;
}

export function ClocheNotifications({ expanded, className }: ClocheNotificationsProps): JSX.Element | null {
  const port = useNotificationsPort();
  if (port === null) return null;
  const badge = texteDuBadge(port.nonLus.total);
  const libelle = badge ? `Notifications, ${port.nonLus.total} non lue${port.nonLus.total > 1 ? 's' : ''}` : 'Notifications';

  return (
    <button type="button" aria-label={libelle} title={libelle} aria-controls="taki-chat-panel"
      onClick={() => ouvrirCentre({ source: 'notifications', lanceur: true })} className={className}>
      <span className="relative flex h-9 w-9 shrink-0 items-center justify-center">
        <IconBellNotification size={17} />
        <Pastille nombre={port.nonLus.total} className="absolute -right-1 -top-1" />
      </span>
      <span className={cn('min-w-0 flex-1 truncate text-left text-[0.8125rem] font-medium transition-opacity duration-300', expanded ? 'opacity-100' : 'opacity-0')}>
        Notifications
      </span>
    </button>
  );
}
